export default {
  setClubJauge: ({ commit }, payload) => {
    commit('setClubJauge', payload);
  },
  setLoadingJauge: ({ commit }, payload) => {
    commit('setLoadingJauge', payload);
  },
};
